
















































































import Vue from 'vue';
import Component from 'vue-class-component';
import MList from '../../../m-list';
import MBadge from '../../index';

Vue.use(MList);
Vue.use(MBadge);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  // TODO
}
